import { combineEpics } from 'redux-observable';
import { filter, mergeMap, map } from 'rxjs/operators';

import { showBannerAlert, Alert } from '../../../app/reducers';
import { RootEpic } from '../../../store/epics';
import { getPromotion, getPromotionSuccess, getPromotionFail } from '../reducer/promotion';

const getPromotionEpic: RootEpic = (action$, _state$, { api }) => {
  return action$.pipe(
    filter(getPromotion.match),
    mergeMap(({ payload }) =>
      api.qualification
        .getPromotion(payload)
        .then((promotion) => getPromotionSuccess(promotion))
        .catch((err: Error) => getPromotionFail(err)),
    ),
  );
};

const getPromotionSuccessEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(getPromotionSuccess.match),
    map(({ payload }) => {
      const bannerAlert: Alert = {
        message: payload.description,
        severity: 'success',
      };
      return showBannerAlert(bannerAlert);
    }),
  );
};

export const promotionEpic = combineEpics(getPromotionEpic, getPromotionSuccessEpic);
